import {Directive, Input, Output, EventEmitter, OnInit} from "@angular/core";

@Directive({
  selector: '[uppercaseBKP]',
  host: {
    '[value]': 'uppercase',
    '(input)': 'format($event.target.value)'
  }
})
export class UppercaseBKPDirective implements OnInit {

  @Input() uppercase: string;
  @Output() uppercaseChange: EventEmitter<string> = new EventEmitter<string>();

  constructor() {
  }

  ngOnInit() {
    this.uppercase = this.uppercase || '';
    this.format(this.uppercase);
  }

  format(value) {
    value = value.toUpperCase();
    this.uppercaseChange.next(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/uppercase_bkp.directive.ts